import { z } from 'zod/v4';

export const AdminUpdateAllowedOriginParamsSchema = z.object({
  id: z.string().min(1),
});

export type AdminUpdateAllowedOriginParams = z.infer<
  typeof AdminUpdateAllowedOriginParamsSchema
>;

// A full replace, as legacy was: every column is written from the body, so an
// omitted `name`, `prettyOrigin` or `companyId` is written as null. Legacy did
// not declare `companyId` at all (it slipped through `additionalProperties`),
// so any type reached the `varchar(36)` column; it is a string now.
export const AdminUpdateAllowedOriginBodySchema = z.object({
  origin: z.string().min(1).max(511),
  name: z.string().max(255).nullish(),
  prettyOrigin: z.string().max(511).nullish(),
  companyId: z.string().max(36).nullish(),
});

export type AdminUpdateAllowedOriginBody = z.infer<
  typeof AdminUpdateAllowedOriginBodySchema
>;
